var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:_vm.spinnerClasses},[_c('div',{staticClass:"spinner-grow text-primary m-auto",style:(_vm.spinnerStyle),attrs:{"role":"status"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }